/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 02.10.12, 16:33
 *
 * $URL$
 * $Rev$
 * $Author$
 * $Date$
 * $Id$
 */
import {JavascriptCallDefaultFactory} from "./JavascriptCallDefaultFactory";
import {AbstractJavascriptFunctionCallFactory} from "./vo/AbstractJavascriptFunctionCallFactory";
import {AbstractJavascriptFunctionCallVO} from "./vo/AbstractJavascriptFunctionCallVO";
import {getLogger} from "@goodgamestudios/logger";
import {ExternalInterface} from "@goodgamestudios/createjs-utilities";
const logger = getLogger("CoreJS.ExternalInterfaceController");

export class ExternalInterfaceController {
    public static VERSION: string = "$Id$";
    public static NAME: string = "ExternalInterfaceController";

    private _javascriptFunctionCallDefaultFactory: JavascriptCallDefaultFactory;

    constructor() {
        this._javascriptFunctionCallDefaultFactory = new JavascriptCallDefaultFactory();
    }

    private static _externalInterfaceController: ExternalInterfaceController;

    public static get instance(): ExternalInterfaceController {
        if (ExternalInterfaceController._externalInterfaceController == null) {
            ExternalInterfaceController._externalInterfaceController = new ExternalInterfaceController();
        }
        return ExternalInterfaceController._externalInterfaceController;
    }

    /**
     All official function names are defined in JavascriptFunctionName.
     If a new function has to added put a new function name constant in that class.
     Maybe you have to create also an new factory class if the call has parameters.

     Full documentation is located here:
     https://docs.google.com/a/goodgamestudios.com/document/d/1YEQHq6cQ3IsCBrwj2VO3nPe4Qu7JarFzKZWP2AgTQc0/edit

     // Usage Options
     // Option 1.
     Pass a javascript function constant name defined in JavascriptFunctionName. Use this option to
     just trigger a function without any arguments.
     E.g.:
     ExternalInterfaceController.instance.executeJavaScriptFunction(JavascriptFunctionName.ON_LOAD);

     // Option 2
     Pass a factory class which composes the needed data for the javascript call. The dependencies will be encapsulated within
     the factory class. Usually you need a factory class
     E.g.:
     ExternalInterfaceController.instance.executeJavaScriptFunction(new JavascriptCallOnLoginCompleteFactory());

     // Option 3
     It's possible triggering a javascript function with just the desired name as a String.
     Normally you should use the predefined constants in JavascriptFunctionName
     E.g.:
     ExternalInterfaceController.instance.executeJavaScriptFunction("iGuessThatIsAJavascriptFunction");

     // Option 4, Return Values
     If the called javascript method has a return value: just grab it.
     E.g.:
     var myReturnValue:String = ExternalInterfaceController.instance.executeJavaScriptFunction("ggsTest") as String;

     @param callObject Expects either a String with a javascript function name (See JavascriptFunctionName.as) or a factory class with the type AbstractJavascriptFunctionCallFactory
     */
    public executeJavaScriptFunction(callObject: AbstractJavascriptFunctionCallFactory | string): any {
        if (typeof  callObject === "string") {
            logger.info(`executing ExternalInterfaceCall from ExternalInterfaceController [Deprecated] ${callObject} - TODO  check behaviour when a callback or return value is expected --> it is now ASYNC`);
            return ExternalInterface.call(callObject);
        }

        var vo: AbstractJavascriptFunctionCallVO = callObject.createVO();

        if (!vo) {
            logger.error("JavascriptFunctionCallVO is null");
            return;
        }
        // TODO  investigate usages and add then   whenever caller expects a result  (externalinterface is now async)
        logger.info(`executing ExternalInterfaceCall for ${vo.functionName} - TODO  check behaviour when a callback or return value is expected --> it is now ASYNC`);
        return ExternalInterface.call(vo.functionName, ...vo.parameters);
    }

}
